export enum SubscriptionPlanEnum {
  Monthly = "Monthly",
  // Quarterly = "Quarterly", // Coming soon
  // Yearly = "Yearly", // Coming soon
}
